import sanityClient from '@sanity/client';

export default sanityClient({
  projectId: 'je7ahhiq', // Replace with your Sanity project ID
  dataset: 'production', // Replace with your dataset name
  useCdn: true, // `true` for faster response, `false` for fresh data
  apiVersion: '2025-04-14', // Use the latest API version
});